module.exports = __webpack_public_path__ + "img/cta-shape.1db2a22e.png";